import { BoxTitles } from "@boxes/BoxTitles";
import { Button, Checkbox, Drawer, Loading } from "@components";
import { ForEach } from "@components/control-statements";
import { OlgaEnvironmentsAPI } from "@providers/OlgaEnvironmentsAPI";
import styles from "@styles/forms-flow/filtered-audience.module.scss";
import classNames from "classnames/bind";
import { useEffect, useState } from "react";
const css = classNames.bind(styles);

export const BrandsAndUnitsConditionalForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
}) => {
  const [brands, setBrands] = useState([]);
  const [units, setUnits] = useState(node?.data?.units || []);
  const [loading, setLoading] = useState(false);

  const getFreshNode = () => {
    return {
      ...node,
      data: {
        ...node?.data,
        units: units,
        quantity: 0,
      },
    };
  };

  const loadBrandAndUnits = async () => {
    setLoading(true);
    const [unitResponse, brandsResponse] = await Promise.all([
      OlgaEnvironmentsAPI.getUnits(),
      OlgaEnvironmentsAPI.getBrands(),
    ]);

    const brandList = brandsResponse.getData([]);
    const unitList = unitResponse.getData([]);

    for (const b of brandList) {
      b.units = unitList.filter((f) => f.brand_id == b.id);
    }

    const unitsWithoutBrand = unitList.filter((f) => !f.brand_id);

    if (unitsWithoutBrand?.length > 0) {
      brandList.push({
        name: "Sem marca",
        units: unitsWithoutBrand,
      });
    }

    setBrands(brandList);
    setLoading(false);
  };

  useEffect(() => {
    visible && loadBrandAndUnits();
  }, [visible]);
  useEffect(() => {
    onChange && onChange(getFreshNode());
  }, [units]);

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={BoxTitles.BrandsAndUnitsFilter}
    >
      {loading ? (
        <div className={styles.loading}>
          <Loading />
        </div>
      ) : (
        <>
          <p className={styles.label}>Selecione as unidades</p>
          <ForEach
            items={brands}
            render={(b) => {
              return (
                <BrandSection
                  brand={b}
                  selectedUnits={units}
                  onToggleUnit={(unitId) => {
                    if (units.indexOf(unitId) > -1) {
                      setUnits(units.filter((u) => u != unitId));
                    } else {
                      setUnits([...units, unitId]);
                    }
                  }}
                  onToggleAll={(checkAll) => {
                    const unitIds = b.units.map((u) => u.id);
                    if (checkAll) {
                      setUnits([...new Set(unitIds)]);
                    } else {
                      setUnits(units.filter((u) => unitIds.indexOf(u) == -1));
                    }
                  }}
                />
              );
            }}
          />
          <div className={styles.footer}>
            <Button
              design="primary"
              className="w-100"
              onClick={() => onSave(getFreshNode())}
            >
              Salvar
            </Button>
          </div>
        </>
      )}
    </Drawer>
  );
};

const BrandSection = ({ brand, selectedUnits, onToggleUnit, onToggleAll }) => {
  const [collapsed, setCollapsed] = useState(false);

  const isSomeChecked = brand.units.reduce(
    (r, u) => r || selectedUnits.includes(u.id),
    false
  );
  return (
    <div className={styles.climateVariant}>
      <div className={styles.header} onClick={() => setCollapsed(!collapsed)}>
        <div className="d-flex align-center">
          <Checkbox
            checked={isSomeChecked}
            onClick={() => onToggleAll(!isSomeChecked)}
          />
          <p>{brand?.name}</p>
        </div>
        <i
          className={css({ "fal fa-chevron-down": true, collapsed: collapsed })}
        />
      </div>

      {collapsed && (
        <div className={`${styles.content} ml-20`}>
          <ForEach
            items={brand.units}
            render={(u) => (
              <Checkbox
                label={u.name}
                checked={selectedUnits.indexOf(u.id) > -1}
                className={"mb-10"}
                onClick={() => onToggleUnit(u.id)}
              />
            )}
          />
        </div>
      )}
    </div>
  );
};
